// @flow
import * as React from 'react';
import {
  darkenHexColor,
  DataGrid, DataGridColumn,  letterToColorfulHex, lightenHexColor, ListPageWrapper,
  PageTitle,
  useUrgentCallRequestsSubscription
} from '../../shared';
import { Avatar, Link as MuiLink, Stack } from '@mui/material';
import { getUserName } from '@coverright/utils';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { getRoute } from '../../app/router';
import { Field, UrgentRequestCallOutput } from '@coverright/data-access/types/enrollment';

export const UrgentCalls = () => {
  const { data, loading } = useUrgentCallRequestsSubscription()

  return (
    <ListPageWrapper>
      <PageTitle title="Urgent call requests" />

      <DataGrid columns={columns}
                hidePaginator
                page={0}
                rowsPerPage={1000}
                total={data?.urgentCallRequests.length || 0}
                loading={loading}
                rows={data?.urgentCallRequests || []}/>
    </ListPageWrapper>
  );
};

const columns: DataGridColumn<UrgentRequestCallOutput, any>[] = [
  {
    title: 'Name',
    value: v => (
      <Stack direction={'row'} alignItems={'center'} gap={1}>
        <Avatar sx={{ bgcolor: lightenHexColor(letterToColorfulHex(v.email || getUserName(v)), 50), color: darkenHexColor(letterToColorfulHex(v.email || getUserName(v)), 70), width: 20, height: 20, fontSize: 12 }}>
          {v.firstName && _.toUpper(v.firstName[0])}
        </Avatar>
        <MuiLink component={Link}
                 color={'text.primary'}
                 sx={{textDecoration: 'none'}}
                 onClick={(event: any) => event.stopPropagation()}
                 to={`/${getRoute('client')}/${v.clientId}`}>
          {getUserName(v)}
        </MuiLink>
      </Stack>
    ),
    sortKey: Field.FirstName
  },
  {
    title: 'Email',
    value: v => (
      <MuiLink component={Link}
               color={'text.primary'}
               sx={{textDecoration: 'none'}}
               onClick={(event: any) => event.stopPropagation()}
               to={`/${getRoute('client')}/${v.clientId}`}>
        {v.email}
      </MuiLink>
    ),
    sortKey: Field.Email
  },
  {
    title: 'Call Type',
    value: v => v.urgentCallType ? _.upperFirst(_.lowerCase(v.urgentCallType)) : ''
  }
]
